import React from 'react';
import Workspace from 'common/components/Workspace';
import { SidebarContainer } from 'common/components/TouchpointEditor/components/TouchpointSidebar';
import EditElementTools from 'common/components/TouchpointEditor/components/TouchpointSidebar/EditElementTools';

import ElementsListMenu from './ElementsListMenu';

export default () => (
    <Workspace.Sidebar>
        <SidebarContainer>
            <ElementsListMenu />
            <EditElementTools />
        </SidebarContainer>
    </Workspace.Sidebar>
);
